<template>

	<v-list-group v-model="active" no-action class="parent-nav"> 
		<v-list-item dense class="px-2" slot="activator">
		<v-list-item-icon class="mr-4"><v-icon :color="iconcolor || 'accent'">{{icon}}</v-icon></v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ name }}</v-list-item-title>
				<v-list-item-subtitle class="font-weight-light">{{ description }}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
		<slot  name="childContent"></slot>
		<NavigationItem class="pl-6" v-for="(child, i) in children" :key="i" v-bind="child">
			<template v-slot:tooltip>
				<slot :name="child.tooltip"></slot>
			</template>
		</NavigationItem>
	</v-list-group>

</template>

<style lang="less">
	.parent-nav{
		.v-list-item{
			padding-left: 0px;
			padding-right: 10px;
		}
	}
</style>

<script type="text/javascript">

// import FancyTooltip from "@/components/elements/FancyTooltip"
import NavigationItem from "@/components/elements/NavigationItem"
export default {
	name:"NavigationGroup",
	props: ["id", "icon", "name", "description", "iconcolor", "tooltip", "children"],
	data: () => {
		return {
			active: false,			
		}
	},
	components: {
		NavigationItem
	}, 
	watch: {
		id: {
			immediate: true, 
			handler(){
				if(( "/" + this.id ) == this.$route.path ){
					this.active = true;
				}
			}
		},
		children: {
			immediate: true, 
			handler(){
				var current_path = this.$route.path;
				var matched = this.children.find((child) => {
					return "/"+child.to == current_path;
				})
				if( matched ){
					this.active = true;
				}

			}
		}
	}
}
</script>